import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { VisualEvent } from '@core/interfaces/visual-event';
import { UrlService } from '@core/services/url.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VisualEventsFetcherService {
  readonly #httpClient = inject(HttpClient);
  readonly #urlService = inject(UrlService);

  public fetchVisualEvents(taskId: string): Observable<VisualEvent[]> {
    const url = this.#urlService.getUrl(`tasks/${taskId}/visual-events`);
    return this.#httpClient.get<VisualEvent[]>(url);
  }
}
